import React from "react";

import { Form as AntForm, FormInstance as AntFormInstance, FormProps as AntFormProps } from "antd";
import type { RuleObject as AntRuleObject } from "antd/es/form";

import { ProductEventProps, productAnalytics, trackMixpanel } from "utils";

type FormProps = AntFormProps & ProductEventProps & { dataTestId?: string; children?: React.ReactNode };
type FormType = React.ForwardRefExoticComponent<FormProps & React.RefAttributes<FormInstance>> & typeof AntForm;

export type FormInstance<T = unknown> = AntFormInstance<T>;
export type RuleObject = AntRuleObject;

const Form = React.forwardRef<FormInstance, FormProps>(
  (
    {
      children,
      form,
      name,
      style,
      className,
      onFinish,
      onFinishFailed,
      onValuesChange,
      initialValues,
      dataTestId,
      productEvent,
      productEventProperties,
      ...other
    },
    ref
  ) => (
    <AntForm
      data-testid={dataTestId}
      name={name}
      onFinish={(v) => {
        trackMixpanel("FinishForm", { form: name || "undefined" });
        if (productEvent) productAnalytics.track(productEvent, productEventProperties);
        onFinish?.(v);
      }}
      onFinishFailed={(v) => {
        trackMixpanel("FinishFailedForm", { form: name || "undefined" });
        onFinishFailed?.(v);
      }}
      onValuesChange={onValuesChange}
      initialValues={initialValues}
      form={form}
      style={style}
      ref={ref}
      className={className}
      {...other}
    >
      {children}
    </AntForm>
  )
) as FormType;

Form.Item = AntForm.Item;
Form.List = AntForm.List;
Form.ErrorList = AntForm.ErrorList;
Form.useForm = AntForm.useForm;
Form.useFormInstance = AntForm.useFormInstance;
Form.useWatch = AntForm.useWatch;
Form.Provider = AntForm.Provider;

export { Form };
